// 繁体中文翻译
export const zhTW = {
  // 主題
  theme: {
    switchToLight: '亮色主題',
    switchToDark: '暗色主題',
    switchToLightTooltip: '切換到亮色主題',
    switchToDarkTooltip: '切換到暗色主題'
  },

  // 導航選單
  nav: {
    menu: '導航選單',
    home: '首頁',
    about: '關於創美',
    news: '新聞資訊',
    careers: '人才招聘',
    investor: '投資者關係',
    contact: '聯絡我們'
  },

  // 頭部導航
  header: {
    supplierService: '供應商服務',
    drugTestQuery: '藥檢單查詢'
  },

  // 導航
  navigation: {
    home: '首頁',
    about: '關於創美',
    aboutCompany: '公司簡介',
    aboutHistory: '發展歷程',
    aboutHonors: '榮譽資質',
    aboutOrganization: '組織架構',
    aboutTeam: '員工風采',
    aboutLogistics: '物流配送中心',
    aboutCulture: '企業文化',
    news: '新聞資訊',
    careers: '人才招聘',
    careersRecruitment: '社會招聘',
    careersSocial: '社會招聘',
    careersCampus: '校園招聘',
    investor: '投資者關係',
    investorService: '投資者服務',
    stockInfo: '股票信息',
    investorAnnouncements: '公告及通函',
    investorFinancialReports: '財務報告',
    investorGovernance: '公司治理',
    investorInquiry: '投資者查詢',
    investorContact: '投資者聯繫方式',
    announcements: '公告及通函',
    contact: '聯絡我們'
  },

  // 客戶服務
  customerService: {
    title: '客戶服務',
    welcome: '您好！有什麼可以幫助您的嗎？',
    phone: '電話諮詢',
    email: '郵件諮詢'
  },

  // 首頁
  home: {
    carousel: {
      ariaLabel: '首頁輪播橫幅'
    },
    about: {
      title: '關於創美',
      description:
        '• 創美藥業（股票代碼：2289.HK）創立於2000年，是華南地區領先的現代醫藥供應鏈綜合服務商。公司始終專注於醫藥非招標市場，以醫藥分銷為核心，融合醫藥諮詢、第三方物流與營銷服務，依託四大現代化醫藥物流中心，配備先進的資訊管理系統與高效自主配送體系，為客戶提供安全、敏捷、一體化的供應鏈解決方案。憑藉智能化、標準化的運營體系和可複製的拓展模式，業務覆蓋廣東，輻射福建、廣西、海南等省份，持續鞏固華南地區的領先優勢。'
    },
    statsGrid: {
      title: '成為中國醫藥健康行業，最具市場競爭力服務商',
      primaryDistribution: '一級經銷品種超80%',
      experience: '年行業積澱',
      suppliers: '家供應商',
      products: '產品品種',
      customers: '客戶',
      logisticsCenters: '大物流中心',
      warehouseArea: '平方米倉儲面積',
      vehicles: '台配送車輛'
    },
    advantages: {
      title: '核心優勢',
      marketing: {
        title: '營銷領航·聚力共贏',
        items: [
          {
            label: '深厚渠道資源',
            content: '匯聚超1500家供應商，擁有10年以上穩固合作根基，經營品規超15000個，一級經銷佔比達80%，是眾多知名OTC品牌在廣東市場的核心戰略夥伴。'
          },
          {
            label: '廣闊客戶網絡',
            content: '終端客戶超萬家，業務範圍全省全覆蓋，輻射到閩、桂、瓊、湘等周邊省市，在華南地區的醫藥非招標市場處於領先地位。'
          },
          {
            label: '資深專業團隊',
            content: '核心團隊擁有逾20年行業積澱，堅持內部培養與鍛造，能深刻洞察客戶需求，提供精準、敏捷的個性化營銷解決方案與高效落地服務。'
          },
          {
            label: '卓越行業地位',
            content: '行業內唯一完全專注於非招標市場業務的大型醫藥流通企業；連續十餘年位列「全國藥品流通行業批發企業35強」「廣東企業500強」。'
          },
          {
            label: '創新業務模式',
            content: '突破傳統多元分銷模式，構建「分銷+倉儲+配送」綜合服務體系；通過渠道下沉實現一級代理直供終端，並自建B2B電商平台「創美e藥」，打造線上線下融合的全渠道營銷生態。'
          }
        ]
      },
      logistics: {
        title: '智慧物流·高效精準',
        items: [
          {
            label: '硬核基建實力',
            content: '擁有4大現代化醫藥物流中心，倉儲總面積超10萬㎡；配備超200輛自有運輸車（冷藏車佔比80%以上），支持「多品種、小批量、高頻次」配送需求，可實現「10公里半徑一日三配、50公里一日兩配、250公里一日一配」。'
          },
          {
            label: '智能技術驅動',
            content: '集成AS/RS自動化立體庫、EWM/WCS/TMS等智能管理系統，結合北斗實時定位與溫濕度監控，實現倉儲管理、運輸調度及作業全流程自動化、可視化，確保高效精準、全程可控。'
          },
          {
            label: '三方物流標杆',
            content: '率先在廣東省內通過醫藥新規第三方物流企業檢查認證，創新實踐B2B2C一體化倉配模式，為客戶提供合規、專業的醫藥供應鏈解決方案。'
          },
          {
            label: '行業標準引領',
            content: '參與起草新版《藥品物流服務規範》國家標準（GB/T 30335-2023），以創美實踐智慧賦能行業標準制定，樹立專業標杆。'
          }
        ]
      },
      digital: {
        title: '數智賦能·質效雙升',
        items: [
          {
            label: '智能分銷體系',
            content: '全面引入雲計算、大數據、人工智能、5G和物聯網等創新科技，將業務場景、GSP管控、物流服務深度融合，構建一體化醫藥供應鏈新生態。'
          },
          {
            label: '數字平台固基',
            content: '自建自營「創美e藥」B2B電商平台，集電子處方、電子首營、自動入庫等應用工具於一體，為醫藥交易提供全流程數字化解決方案。'
          },
          {
            label: 'AI全域賦能',
            content: '推進全流程信息化、營銷AI輔助、RPA自動流程機器人辦公，實現供應鏈全流程服務自動化、決策數據化、運營智能化。'
          }
        ]
      },
      quality: {
        title: '質量監管·安全省心',
        items: [
          {
            label: '全員質量文化',
            content: '恪守「質量第一、預防為主、全員參與」方針，將質量意識融入企業文化血脈。'
          },
          {
            label: '全程溯源體系',
            content: '建立完善的質量管理體系，實現對藥品進、存、銷、運各環節全過程可追溯、可跟蹤，確保流轉鏈條清晰透明。'
          },
          {
            label: '全時嚴格執行',
            content: '以超GSP標準實施常態化質量管控，通過定期巡檢與突擊飛檢相結合，持續強化質量監管力度，堅守安全底線。'
          }
        ]
      }
    },
    news: {
      title: '公司動態',
      subtitle: '了解創美藥業的最新發展和重要事件',
      viewAll: '查看全部動態'
    },
    partners: {
      title: '合作夥伴',
      subtitle: '與全球知名企業攜手共進，共創美好未來'
    }
  },

  // 關於我們頁面
  about: {
    hero: {
      title: '關於創美藥業',
      subtitle: '專注醫藥分銷，守護人類健康'
    },
    company: {
      hero: {
        title: '公司簡介',
        subtitle: '專注醫藥分銷，服務健康中國'
      },
      intro: {
        title: '關於創美',
        content: '創美藥業（股票代碼：02289.HK）成立於2000年，始終深耕醫藥流通市場，持續夯實醫藥分銷業務，積極拓展第三方物流等增值業務，業務範圍全面覆蓋廣東，輻射閩、桂、瓊等省份，並依托高效協同的四大現代化醫藥物流中心，為客戶提供精準適配的一體化供應鏈解決方案，已成為華南地區領先的現代醫藥供應鏈綜合服務商。'
      },
      missionVision: {
        title: '使命與願景',
        mission: {
          title: '公司使命',
          slogan: '創造健康美好生活',
          content: '擔當億萬中國家庭的健康守門人，保障醫藥供應鏈的高效與可靠。'
        },
        vision: {
          title: '公司願景',
          slogan: '成為中國醫藥健康產業最具市場競爭力服務商',
          content: '引領中國醫藥健康產業與供應鏈的創新發展，成為醫藥健康領域最受信賴的首選夥伴。'
        }
      },
      mission: {
        title: '公司使命',
        content: '擔當億萬中國家庭的健康守門人，保障醫藥供應鏈的高效與可靠。'
      },
      vision: {
        content: '引領中國醫藥健康產業與供應鏈的創新發展，成為醫藥健康領域最受信賴的首選夥伴。'
      },
      culture: {
        title: '企業文化',
        coreValues: {
          title: '核心價值觀'
        },
        spirit: {
          title: '企業精神',
          content: '實幹進取，快樂奮鬥'
        },
        businessPhilosophy: {
          title: '經營理念',
          content: '誠信經營、利他利眾、合作共贏'
        },
        servicePhilosophy: {
          title: '服務理念',
          content: '真誠服務，真心付出'
        },
        employeePhilosophy: {
          title: '員工理念',
          content: '尊重、關愛、善待、培育'
        },
        employeeImage: {
          title: '員工形象',
          content: '活力、真誠、效率，以真理為中心'
        },
        workPhilosophy: {
          title: '工作理念',
          content: '堅韌、負責、合作、高效'
        }
      },
      values: {
        title: '核心價值觀',
        innovation: {
          title: '創新',
          description: '持續創新，引領行業發展'
        },
        quality: {
          title: '品質',
          description: '追求卓越品質，確保藥品安全'
        },
        integrity: {
          title: '誠信',
          description: '誠信經營，贏得客戶信賴'
        },
        collaboration: {
          title: '協作',
          description: '團隊協作，共創價值'
        }
      }
    },
    history: {
      hero: {
        title: '發展歷程',
        subtitle: '25年砥礪前行，鑄就行業典範'
      },
      title: '發展歷程',
      subtitle: '從創立至今，創美藥業始終堅持專業發展，不斷完善醫藥分銷服務體系',
      intro: '深耕醫藥非招標市場多年，從行業新銳到華南地區領先的現代化醫藥供應鏈服務商，創美藥業的成長與蛻變，源於一段篳路藍縷、銳意進取的發展征程。',
      timeline: {
        title: '重要里程碑'
      },
      1999: {
        title: '籌備階段',
        description: '創美藥業開始籌備，奠定發展基礎。'
      },
      2005: {
        title: '業務擴展',
        description: '建立第一個現代化配送中心，業務範圍擴展至廣東全省，與多家知名藥企建立合作關係。'
      },
      2010: {
        title: '區域佈局',
        description: '在福建、廣西設立分支機構，形成華南三省的分銷網絡，成為區域內重要的醫藥分銷企業。'
      },
      2015: {
        title: '智慧升級',
        description: '投資建設現代化物流中心，引進先進的倉儲管理系統，提升配送效率和服務質量。'
      },
      2020: {
        title: '數字化轉型',
        description: '全方位數字化轉型，建立智能化供應鏈管理系統，運用大數據技術提升運營效率。'
      },
      2024: {
        title: '服務創新',
        description: '在海南設立第四個配送中心，實現華南四省全覆蓋，持續創新服務模式，提升客戶體驗。'
      }
    },
    team: {
      title: '核心團隊',
      subtitle: '匯聚行業精英，打造專業團隊，為企業發展提供強有力的人才保障',
      members: {
        ceo: {
          name: '張明華',
          position: '董事長兼CEO',
          bio: '醫學博士，擁有20年醫藥行業經驗，曾任職於多家知名製藥企業，在藥物研發和企業管理方面具有豐富經驗。'
        },
        cto: {
          name: '李雪梅',
          position: '首席技術官',
          bio: '藥學博士，國際知名藥物化學專家，主導多個創新藥物的研發工作，擁有30餘項國際專利。'
        },
        cfo: {
          name: '王麗娟',
          position: '首席財務官',
          bio: 'MBA碩士，註冊會計師，在醫藥行業財務管理和投資併購方面有著豐富的實戰經驗。'
        },
        rdDirector: {
          name: '陳志強',
          position: '研發總監',
          bio: '生物醫學博士，專注於腫瘤和免疫治療領域研究15年，帶領團隊完成多個重要項目的臨床試驗。'
        },
        marketingDirector: {
          name: '劉曉燕',
          position: '市場總監',
          bio: '市場營銷碩士，在醫藥市場推廣和品牌建設方面有著深厚的專業功底和豐富的實踐經驗。'
        },
        operationsDirector: {
          name: '趙建國',
          position: '運營總監',
          bio: '工程碩士，專注於製藥工藝優化和質量管理，確保生產過程的高效性和產品質量的穩定性。'
        }
      }
    },
    honors: {
      title: '榮譽資質',
      hero: {
        title: '榮譽資質',
        subtitle: '專業認證，值得信賴'
      },
      intro: '伴隨著綜合實力的不斷強大，創美藥業的品牌影響力與價值也不斷提升，一系列榮譽的獲得，彰顯了企業實力，也印證了企業不斷追求卓越的堅實足跡。',
      dataNote: '（數據截至2025年）',
      list: {
        item1: '廣東企業500強',
        years1: '連續15年',
        item2: '全國藥品流通行業批發企業34強',
        years2: '榮登百強榜超14年',
        item3: '醫藥冷鏈最佳物流中心',
        years3: '連續6年',
        item4: '醫藥冷鏈物流服務推薦企業',
        years4: '連續6年',
        item5: '藥品三方現代物流服務能力TOP50',
        years5: '連續2年',
        item6: '中國數智物流創新應用金螞蟻創新獎',
        years6: '連續7年',
        item7: '現代醫藥物流技術試驗基地（中心）',
        years7: '連續3年',
        item8: '醫藥物流配送優秀企業',
        years8: '連續4年',
        item9: '廣東省誠信興商企業',
        years9: '連續13年',
        item10: '2023年智慧醫藥供應鏈一體化服務「優秀案例獎」',
        item11: '2023年度最佳醫藥營銷團隊',
        item12: '2022年中國醫藥供應鏈銳意企業'
      },
      conclusion: '未來，在「創造健康美好生活」的使命引領下，創美藥業將持續以加速奔跑的姿態，堅定邁向「中國醫藥健康產業最具市場競爭力服務商」的目標高地，為健康事業注入奔騰不息的創美動能！'
    },
    org: {
      structure: {
        title: '組織結構'
      },
      board: {
        title: '董事會',
        name: '董事會'
      },
      management: {
        title: '管理層'
      },
      ceo: '總經理',
      vp: '副總經理',
      departments: {
        title: '職能部門'
      },
      sales: '銷售部',
      procurement: '採購部',
      logistics: '物流部',
      quality: '質量管理部',
      finance: '財務部',
      hr: '人力資源部',
      it: '信息技術部',
      admin: '行政部'
    },
    culture: {
      values: {
        title: '文化理念',
        subtitle: '創美藥業秉承"誠信、創新、專業、共贏"的企業文化，致力於為員工創造良好的工作環境，為客戶提供優質的服務，為社會創造更大的價值。'
      },
      teamwork: {
        title: '團隊協作',
        desc: '凝聚團隊力量，共創美好未來'
      },
      innovation: {
        title: '創新進取',
        desc: '勇於創新，追求卓越'
      },
      customer: {
        title: '客戶至上',
        desc: '以客戶需求為導向，提供優質服務'
      },
      quality: {
        title: '質量第一',
        desc: '嚴格質量管理，確保產品安全'
      },
      responsibility: {
        title: '社會責任',
        desc: '承擔社會責任，回饋社會'
      },
      excellence: {
        title: '追求卓越',
        desc: '不斷提升，追求卓越品質'
      }
    },
    organization: {
      hero: {
        title: '組織架構',
        subtitle: '科學管理，高效運營'
      },
      pageTitle: '組織架構',
      loading: '載入中...',
      empty: '暫無組織架構數據'
    },
    teamStyle: {
      hero: {
        title: '員工風采',
        subtitle: '專業團隊，共創輝煌'
      },
      intro: {
        title: '專業團隊·共創未來',
        content: '創美藥業擁有一支專業、敬業的團隊。我們注重員工的成長與發展，為員工提供良好的工作環境和發展平台，共同創造美好未來。'
      },
      highlights: {
        professional: {
          title: '專業團隊',
          desc: '匯聚行業精英，打造專業化服務團隊'
        },
        growth: {
          title: '成長平台',
          desc: '提供完善的培訓體系和職業發展通道'
        },
        care: {
          title: '員工關懷',
          desc: '關注員工身心健康，營造溫馨工作氛圍'
        },
        achievement: {
          title: '共創輝煌',
          desc: '攜手並進，共同創造美好未來'
        }
      },
      gallery: {
        title: '團隊風采'
      }
    },
    video: {
      company: {
        title: '企業宣傳片',
        subtitle: '通過視頻了解創美藥業的發展歷程、企業文化和服務理念'
      },
      note: '注：請將上述視頻鏈接替換為實際的企業宣傳視頻'
    },
    logistics: {
      hero: {
        title: '物流配送中心',
        subtitle: '專業物流，安全高效'
      },
      intro: {
        title: '物流中心簡介',
        content: '公司擁有汕頭、廣州、深圳、珠海四大現代化物流中心，形成總面積超10萬平方米的智能倉儲集群，配備專業物流車隊超200輛，其中冷藏車佔比80%，全面保障藥品儲運品質。作為廣東省首家通過新版第三方醫藥物流標準認證的企業，公司憑藉先進的設施與管理體系，為客戶提供多溫層、全批次、可追溯的精準物流服務。'
      },
      features: {
        title: '核心優勢'
      },
      storage: {
        title: '現代化倉儲',
        desc: '配備先進的倉儲設施，確保藥品存儲安全'
      },
      delivery: {
        title: '專業配送',
        desc: '專業的冷鏈配送車隊，保障藥品運輸質量'
      },
      quality: {
        title: '質量保證',
        desc: '嚴格的質量管理體系，確保藥品安全'
      },
      speed: {
        title: '快速響應',
        desc: '24小時內完成配送，滿足客戶需求'
      },
      efficiency: {
        title: '高效運營',
        desc: '智能化管理系統，提升運營效率'
      },
      coverage: {
        title: '廣泛覆蓋',
        desc: '覆蓋華南地區50+城市'
      },
      stats: {
        area: '平方米倉儲面積',
        vehicles: '輛配送車輛',
        cities: '個服務城市',
        delivery: '配送時效'
      }
    }
  },

  // 新聞資訊頁面
  news: {
    hero: {
      title: '新聞資訊',
      subtitle: '了解創美最新的最新動態'
    },
    categories: {
      company: '公司新聞',
      media: '媒體報導'
    },
    readMore: '閱讀更多',
    relatedNews: '相關新聞',
    detail: {
      readTime: '閱讀時間',
      notFound: '新聞不存在',
      notFoundDesc: '抱歉，您訪問的新聞不存在或已被刪除'
    }
  },

  // 人才招聘頁面
  careers: {
    backToList: '返回列表',
    emailSubjectTip: '請在郵件主題中註明應聘職位',
    fetchError: '獲取職位詳情失敗',
    jobDescription: '職位描述',
    jobNotFound: '職位不存在',
    noJobs: '暫無招聘職位',
    requirements: '任職要求',
    responsibilities: '工作職責',
    sendResumeTo: '請將簡歷發送至',
    submitResume: '投遞簡歷'
  },

  // 投資者關係頁面
  investor: {
    hero: {
      title: '投資者關係',
      subtitle: '透明、及時的資訊披露，與投資者共同成長'
    },
    financialReports: {
      hero: {
        title: '財務報告',
        subtitle: '透明公開的財務資訊，為投資者提供全面的業績數據'
      },
      filter: {
        all: '全部報告',
        annual: '年度報告',
        interim: '中期業績報告'
      },
      actions: {
        preview: '預覽',
        download: '下載'
      },
      loading: '載入中...',
      empty: '暫無財務報告',
      pagination: {
        total: '共 {{total}} 條'
      }
    },
    announcements: {
      hero: {
        title: '公告及通函',
        subtitle: '查看公司最新的公告和通函文件'
      },
      sectionTitle: '公告及通函',
      yearSuffix: '年',
      preview: '預覽',
      download: '下載',
      empty: '暫無公告',
      total: '共 {{total}} 條'
    },
    inquiry: {
      hero: {
        title: '投資者聯繫方式',
        subtitle: '為投資者提供便捷的聯繫方式和諮詢服務'
      },
      companyName: '創美藥業股份有限公司',
      financialPR: '財經公關公司',
      financialPRName: '智信財經公關顧問有限公司',
      address: '地址：',
      phone: '電話：',
      email: '郵箱：',
      postcode: '郵編：'
    },
    governance: {
      hero: {
        title: '公司治理',
        subtitle: '規範透明的公司治理結構，保障股東權益'
      },
      tabs: {
        info: '企業資料',
        governance: '企業管制',
        communication: '向股東發出公司通訊的方式'
      },
      companyInfo: {
        registeredOffice: '註冊辦事處',
        chinaHeadquarters: '中國總部',
        hkPrincipalPlace: '香港主要營業地點',
        companyWebsite: '公司網站',
        jointCompanySecretaries: '聯席公司秘書',
        authorizedRepresentatives: '授權代表',
        hShareRegistrar: 'H股證券登記處',
        hkCentralSecurities: '香港中央證券登記有限公司',
        china: '中國',
        guangdong: '廣東省',
        shantouLonghu: '汕頭市龍湖區',
        songshanRoad: '嵩山北路235號',
        hongkong: '香港',
        wanchai: '灣仔',
        queensRoad: '皇后大道東248號',
        sunlightTower: '大新金融中心40樓',
        secretary1: '姚潔晦',
        secretary2: '黃慧玲',
        representative1: '姚潔晦',
        representative2: '魭玉燕',
        foshanChancheng: '佛山市禪城區',
        foshanRoad: '佛山大道北65號',
        queensRoad183: '灣仔皇后大道東183號',
        hopewellCentre: '合和中心17樓',
        room1712: '1712–1716室'
      },
      sections: {
        corporateGovernance: '企業管制',
        regulations: '規章制度',
        antiCorruption: '反貪污及舉報政策與程序',
        reportingChannel: '舉報渠道'
      },
      actions: {
        read: '閱讀',
        download: '下載',
        loading: '載入中...',
        noDocuments: '暫無文件'
      },
      communication: {
        intro: '根據《香港聯合交易所有限公司證券上市規則》，公司已採用以電子方式發布公司通訊之安排，並在公司網站',
        and: '及香港聯合交易所「披露易」網站',
        introEnd: '上向公司股東提供及發布公司通訊。',
        definition: '「公司通訊」指公司已發出或將予發出以供其任何股東參照或採取行動的任何文件，其中包括但不限於(a)董事報告、年度賬目以及審計報告副本以及（如適用）財務摘要報告；(b)中期報告及其中期報告摘要（如適用）；(c)會議通知；(d)上市文件；(e)通函；及(f)代表委任表格。',
        downloadNotice: '公司登記股東和非登記股東用作選取可供採取行動的公司通訊之收取方式及/或要求印刷本的通知信函及回條可透過以下鏈接下載：',
        registeredLink: '供登記股東使用的以電子方式發布公司通訊之安排之通知信函及回條',
        nonRegisteredLink: '供非登記股東使用的以電子方式發布公司通訊之安排之通知信函及回條',
        hkexDownload: '同時，股東亦可於香港聯合交易所「披露易」網站下載上述通知信函及回條。',
        emailNotice: '如股東已提供其有效電子郵件地址，股東於每次公司發布可供採取行動的公司通訊時將會以電子郵件收到可供採取行動的公司通訊。如股東需收取公司通訊印刷版，請填寫及向公司股份過戶處提交以上回條，或發送電子郵件至',
        emailNoticeEnd: '，並註明股東姓名、地址以及提出收取公司通訊印刷版的要求。請注意，收取未來公司通訊印刷版之指示由收悉股東指示當日起計一年內有效，此後將過期。'
      }
    },
    stock: {
      service: '投資者服務',
      listed: '港股上市',
      marketCap: '市值',
      volume: '成交量',
      loading: '載入中...',
      open: '今開',
      close: '昨收',
      high: '最高',
      low: '最低',
      yesterday: '昨收',
      intraday: '分時走勢',
      updateTime: '更新時間',
      refresh: '刷新',
      tabs: {
        chart: '分時',
        detail: '日K'
      },
      bidAsk: {
        level: '檔位',
        bid: '買價',
        bidVolume: '買量',
        ask: '賣價',
        askVolume: '賣量',
        levelLabel: '買{{level}}/賣{{level}}'
      }
    }
  },

  // 聯絡我們頁面
  contact: {
    hero: {
      title: '聯絡我們',
      subtitle: '我們期待與您的溝通交流'
    },
    info: {
      title: '聯絡資訊',
      addressLabel: '地址/ADD：',
      phoneLabel: '電話/TEL：',
      postcodeLabel: '郵編/P.C.：'
    },
    companies: [
      {
        nameCn: '創美藥業股份有限公司',
        nameEn: 'Charmacy Pharmaceutical Co., Ltd.',
        address: '汕頭市龍湖區嵩山北路235號'
      },
      {
        nameCn: '廣東創美藥業有限公司',
        nameEn: 'Guangdong Charmacy Pharmaceutical Co., Ltd.',
        address: '佛山市禪城區祖廟街道汾江北路38號首層11-14號、64-65號，四層79-103號'
      },
      {
        nameCn: '珠海創美藥業有限公司',
        nameEn: 'Zhuhai Chuangmei Hengxiang Pharmaceutical Co., Ltd.',
        address: '珠海市香洲區華威路919號1棟二樓'
      },
      {
        nameCn: '廣州創美藥業有限公司',
        nameEn: 'Guangzhou Charmacy Pharmaceutical Co., Ltd.',
        address: '廣州市南沙區東涌鎮瀝裕街33號'
      },
      {
        nameCn: '惠州創美藥業有限公司',
        nameEn: 'Huizhou Charmacy Pharmaceutical Co., Ltd.',
        address: '博羅縣羅陽街道寨頭創享大廈第4層第06房'
      },
      {
        nameCn: '深圳創美藥業有限公司',
        nameEn: 'Shenzhen Charmacy Pharmaceutical Co., Ltd.',
        address: '深圳市龍崗區保安社區賜昌路8號創美藥業'
      }
    ],
    financialPR: {
      title: '財經公關公司',
      nameCn: '皓天財經集團控股有限公司',
      nameEn: 'Wonderful Sky Financial Group Holdings Limited',
      addressLabel: '地址：',
      addressSz: '深圳市福田區金田路4028號榮超經貿中心1412室',
      hkAddressLabel: '香港主要營業地址：',
      addressHk: '香港灣仔港灣道6-8號瑞安中心9樓'
    },
    feedback: {
      title: '投訴與建議',
      subtitle: '請填寫以下資訊，我們會儘快與您聯絡',
      name: '姓名',
      namePlaceholder: '請輸入您的姓名',
      nameRequired: '請輸入您的姓名',
      phone: '電話',
      phonePlaceholder: '請輸入您的電話',
      phoneRequired: '請輸入您的電話',
      phoneInvalid: '請輸入有效的手機號碼',
      email: '郵箱（選填）',
      emailPlaceholder: '請輸入您的郵箱',
      emailInvalid: '請輸入有效的郵箱地址',
      category: '類別',
      categoryPlaceholder: '請選擇類別',
      categoryRequired: '請選擇類別',
      categoryComplaint: '投訴',
      categorySuggestion: '建議',
      categoryCorruption: '貪污舉報',
      subject: '主題',
      subjectPlaceholder: '請輸入主題',
      subjectRequired: '請輸入主題',
      message: '留言內容',
      messagePlaceholder: '請輸入您的留言內容',
      messageRequired: '請輸入留言內容',
      submit: '提交',
      submitSuccess: '提交成功！我們會儘快與您聯絡。',
      submitError: '提交失敗，請稍後重試。'
    },
    shareholderCommunication: {
      title: '向股東發起通訊的方式'
    }
  },

  // 404頁面
  notFound: {
    title: '頁面未找到',
    description: '抱歉，您訪問的頁面不存在或已被移除。',
    backHome: '返回首頁',
    goBack: '返回上頁'
  },

  // 通用
  common: {
    admin: '管理員',
    back: '返回',
    backToList: '返回列表',
    close: '關閉',
    languageSwitch: '語言切換',
    minutes: '分鐘',
    noData: '暫無數據',
    selectLanguage: '選擇語言'
  },

  // SEO 配置
  seo: {
    home: {
      title: '創美藥業 - 創造健康美好生活',
      description: '創美藥業專注於醫藥分銷與健康服務，致力於創造健康美好生活',
      keywords: '創美藥業,醫藥分銷,健康服務,藥品供應鏈'
    },
    about: {
      title: '關於我們 - 創美藥業',
      description: '了解創美藥業的發展歷程、企業文化和核心價值觀',
      keywords: '創美藥業,公司簡介,企業文化,發展歷程'
    },
    news: {
      title: '公司動態 - 創美藥業',
      description: '了解創美藥業的最新發展和重要事件',
      keywords: '創美藥業,公司新聞,行業動態,企業資訊'
    },
    careers: {
      title: '人才招聘 - 創美藥業',
      description: '加入創美藥業，共創美好未來',
      keywords: '創美藥業,招聘,職位,人才'
    },
    investor: {
      title: '投資者關係 - 創美藥業',
      description: '創美藥業投資者關係信息',
      keywords: '創美藥業,投資者關係,財務報告,公司治理'
    },
    contact: {
      title: '聯繫我們 - 創美藥業',
      description: '聯繫創美藥業，我們期待與您溝通',
      keywords: '創美藥業,聯繫方式,客戶服務'
    }
  }
};
